import Vue from 'vue'
import App from './App.vue'
import router from './router' // [代码修改] 确保 router 导入, PWA 重定向需要它
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index.js'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'aos/dist/aos.css';
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)


// [代码优化] PWA Service Worker 注册逻辑
if ('serviceWorker' in navigator) {
  // 等待页面完全加载后再注册 Service Worker，以避免影响首屏加载性能
  window.addEventListener('load', () => {
    // 注册位于 public 目录下的 sw.js 文件
    navigator.serviceWorker.register('/sw6.js').then(registration => {
      // 注册成功
      console.log('YAAHP ServiceWorker registration successful with scope: ', registration.scope);
    }).catch(err => {
      // 注册失败
      console.log('YAAHP ServiceWorker registration failed: ', err);
    });
  });
}


/**
 * @description 动态更新 PWA Manifest 和站点元数据
 * @param {object} siteInfo - 从 store 获取的站点信息
 */
function updatePwaManifest(siteInfo) {
  if (!siteInfo) {
    console.warn('PWA: 未能获取 siteInfo, 无法动态更新 manifest。');
    return;
  }

  // 1. 动态更新文档标题 (使用 site_title)
  document.title = siteInfo.site_title || '站点加载中...';

  // 2. 动态更新 Favicon
  const faviconLink = document.querySelector('link[rel="icon"]');
  if (faviconLink && siteInfo.site_favicon_url) {
    faviconLink.href = siteInfo.site_favicon_url;
  }

  // 3. 获取当前应用的根 URL (例如 "http://localhost:8081")
  const baseUrl = window.location.origin;

  // 4. 构造动态 Manifest
  const manifest = {
    // 使用 site_brand_name 作为 PWA 的名称
    name: siteInfo.site_brand_name || 'NVivoAi',
    short_name: siteInfo.site_brand_name || 'NVivoAi',
    // 使用 site_description
    description: siteInfo.site_description || '专业的层次分析法建模工具',
    // 使用绝对 URL，并附带查询参数用于启动时重定向
    start_url: `${baseUrl}/?pwa_redirect_path=/nvivo/loading`,
    scope: `${baseUrl}/`, // scope 也必须是绝对 URL
    display: "standalone",
    background_color: "#ffffff",
    theme_color: "#0054fe",
    icons: []
  };

  // 5. ====================【关键修改】====================
  // 中文注释：始终使用 API 提供的 URL
  // (API 提供的必须是绝对路径)
  if (siteInfo.pwa_192_url) {
    manifest.icons.push({
      src: siteInfo.pwa_192_url,
      sizes: "192x192",
      type: "image/png"
    });
  }
  if (siteInfo.pwa_512_url) {
    manifest.icons.push({
      src: siteInfo.pwa_512_url,
      sizes: "512x512",
      type: "image/png"
    });
  }
  // ==================================================


  // 6. 将 Manifest 转换为 data URL
  const manifestJSON = JSON.stringify(manifest);
  const manifestUrl = 'data:application/json;charset=utf-8,' + encodeURIComponent(manifestJSON);

  // 7. 动态创建或更新 <link rel="manifest"> 标签
  let manifestLink = document.getElementById('dynamic-manifest');
  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.id = 'dynamic-manifest';
    manifestLink.rel = 'manifest';
    document.head.appendChild(manifestLink);
  }
  manifestLink.href = manifestUrl;

  console.log('PWA: 动态 Manifest 已注入 (使用 data: URL)。', manifest);
}

/**
 * @description 挂载 Vue 应用程序
 */
function mountVueApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App) // 等同于 template: '<App/>'
  }).$mount('#app') // #app 对应 public/index.html 中的挂载点
}

/**
 * @description 异步初始化函数
 * 在挂载 Vue 之前获取必要的站点设置
 */
async function initializeApp() {
  try {
    // 1. 获取当前域名
    const domain = window.location.hostname;

    // 2. 异步获取站点配置
    const siteInfo = await store.dispatch('site/fetchSiteSettings', { domain });

    // 3. 如果获取成功, 更新 PWA 设置
    if (siteInfo) {
      updatePwaManifest(siteInfo);
    } else {
      console.warn('初始化: 未能从API获取 siteInfo，PWA 将使用默认或无配置。');
    }

    // 4. PWA 启动 URL 重定向逻辑
    const urlParams = new URLSearchParams(window.location.search);
    const pwaRedirectPath = urlParams.get('pwa_redirect_path'); // e.g., /nvivo/loading

    if (pwaRedirectPath) {
      console.log(`PWA 启动重定向: 检测到 pwa_redirect_path=${pwaRedirectPath}`);
      // 使用 Vue Router (它处于 hash 模式) 导航到正确的路径
      router.replace(pwaRedirectPath);

      // 清理 URL 栏中的查询参数
      const newHash = '#' + pwaRedirectPath;
      const newUrl = window.location.pathname + newHash; // 变为: /#/nvivo/loading
      history.replaceState(null, '', newUrl);
    }

  } catch (error) {
    // 5. 处理 API 异常
    console.error('应用初始化失败(fetchSiteSettings):', error);
  } finally {
    // 6. 无论成功与否, 都挂载 Vue 应用
    mountVueApp();
  }
}

// 执行初始化
initializeApp();